<template lang="html">
  <!-- Text, Select, Multiselect, Range, Datepicker, Textarea, Checkbox -->
  <div class="form-group" :class="theClass">
    <v-text class="form-label" v-if="$slots.default" tag="label" :for="id">
      <slot></slot>
    </v-text>
    <div class="input-group">
      <div v-if="prepend" class="input-group-prepend">
        <span class="input-group-text">{{ prepend }}</span>
      </div>

      <!-- Range -->
      <vue-slider
        v-if="type == 'range'"
        v-model="value"
        v-bind="defaultInputProps"
        @callback="change"
        class="form-control"
        :class="expandSlider ? 'expandSlider' : ''"
        ref="slider"
        :min="min"
        :max="max"
        :interval="interval"
        :tooltip="tooltip"
      ></vue-slider>

      <!-- Multiselect -->
      <multiselect
        v-else-if="
          type == 'select' ||
            type == 'multiselect' ||
            type == 'tag' ||
            type == 'multitag'
        "
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        :options="options"
        :multiple="type == 'multiselect' || type == 'multitag' ? true : false"
        :taggable="type == 'tag' || type == 'multitag' ? true : false"
        @tag="addTag"
        tag-placeholder="Adicionar tag"
        deselectLabel=""
        selectedLabel=""
        selectLabel=""
        :label="option_label_list"
      >
        <template slot="noResult">Tag não encontrada.</template>
      </multiselect>

      <!-- Datepicker -->
      <datepicker
        v-else-if="type == 'datepicker'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        :format="dateFormat"
        :language="ptBR"
        :use-utc="true"
        :minimumView="minimumView"
        :maximumView="maximumView"
      ></datepicker>

      <!-- Textarea -->
      <textarea
        v-else-if="type == 'textarea'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        :class="autoheight ? 'autoheight' : ''"
        :rows="rows"
      ></textarea>

      <!-- Checkbox -->
      <input
        v-else-if="type == 'checkbox'"
        v-model="value"
        @change="change"
        :type="type"
        :id="id"
      />



      <!-- Repassword -->


      <input
        v-else-if="type == 'repassword'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="
          change();
          checkPassword();
        "
        class="form-control"
        type="password"
        :max="max"
        :min="min"
      />

      <!-- Autocomplete -->
      <vue-autosuggest
        v-else-if="type == 'autocomplete'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        :showNoResults="false"
        :suggestions="[
          {
            data: [
              'Frodo',
              'Samwise',
              'Gandalf',
              'Galadriel',
              'Faramir',
              'Éowyn',
            ],
          },
        ]"
      >
      </vue-autosuggest>
      <!-- Input -->
      <the-mask
        v-else-if="type == 'tel'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        mask="(##) #####-####"
      >
      </the-mask>
      <the-mask
        v-else-if="type == 'date'"
        v-model="value"
        v-bind="defaultInputProps"
        type="text"
        @input="change"
        class="form-control"
        mask="##/##/####"
      >
      </the-mask>
      <the-mask
        v-else-if="type == 'cpf'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        mask="###.###.###-##"
      >
      </the-mask>
      <the-mask
        v-else-if="type == 'cnpj'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        mask="##.###.###/####-##"
      >
      </the-mask>
      <the-mask
        v-else-if="type == 'zipcode'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        mask="#####-###"
      >
      </the-mask>
      <the-mask
        v-else-if="type == 'integer'"
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        mask="#####"
      >
      </the-mask>
      <money
        v-else-if="type == 'money'"
        v-model.lazy="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
      >
      </money>
      <input
        v-else
        v-model="value"
        v-bind="defaultInputProps"
        @input="change"
        class="form-control"
        :max="max"
        :min="min"
        :step="step"
      />

      <div v-if="append" class="input-group-prepend">
        <span class="input-group-text">{{ append }}</span>
      </div>
    </div>
    <!-- HELP TEXT -->
    <small v-if="error" class="form-help-text text-danger">{{ error }}</small>
    <small v-if="helptext" class="form-help-text text-muted">{{
      helptext
    }}</small>
    <small v-if="repasswordSame" class="form-help-text text-muted"
      >A senha está diferente</small
    >
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'; // https://github.com/shentao/vue-multiselect
import vueSlider from 'vue-slider-component'; // https://github.com/NightCatSama/vue-slider-component
import Datepicker from 'vuejs-datepicker'; // https://github.com/charliekassel/vuejs-datepicker
import { ptBR } from 'vuejs-datepicker/dist/locale';
import jQuery from 'jquery/dist/jquery.js';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  components: {
    vueSlider,
    Multiselect,
    Datepicker,
  },
  props: {
    value: {},
    value2: { default: true },
    prepend: {},
    append: {},
    label: { default: '' },
    type: { default: 'text' },
    name: { default: '' },
    placeholder: { default: '' },
    helptext: { default: '' },
    error: { default: '' },
    id: { type: String },
    autoheight: { type: Boolean },
    disabled: { type: Boolean },
    repassword: { default: '', type: String },
    repasswordSame: { default: '', type: String },
    min: { type: Number },
    max: { type: Number },
    step: { default: 1, type: Number },
    expandSlider: { default: false, type: Boolean },

    options: { type: Array },
    autocomplete: { type: Object },
    rows: {},
    minimumView: { type: String, default: 'day' },
    maximumView: { type: String, default: 'year' },
    tooltip: { default: false }, // 'hover', 'always', false
    interval: { type: Number, default: 1 },
    refresh: { default: false },
    size: { default: 3, type: Number },
    option_label_list: { default: '', type: String },
    dateFormat: { type: String, default: 'dd/MM/yyyy' },
  },
  computed: {
    theClass() {
      let c = 'form-' + this.type + ' size-' + this.size;
      if (this.error) {
        c += ' is-invalid';
      }
      return c;
    },
    // hasSlotData() {
    //   return this.$slots.default
    // },
    defaultInputProps() {
      return {
        id: this.id,
        type: this.type,
        placeholder: this.placeholder,
        value: this.value,
        disabled: this.disabled,
      };
    },
  },
  data() {
    return {
      repasswordOk: false,
      ptBR,
    };
  },
  mounted() {
    $('textarea').keyup(function(e) {
      if ($(this).hasClass('autoheight')) {
        $(this).height(30);
        $(this).height(
          this.scrollHeight +
            parseFloat($(this).css('borderTopWidth')) +
            parseFloat($(this).css('borderBottomWidth'))
        );
      }
    });
  },
  methods: {
    checkPassword() {
      if (this.value != this.repassword) {
        this.repasswordSame = true;
      } else {
        this.repasswordSame = false;
      }
    },
    getLabel(item) {
      return item.name;
    },
    change() {
      this.$emit('change');
      this.$emit('input', this.value); // PRA FAZER O BINDING
    },
    addTag(newTag) {
      this.options.push(newTag);
      this.value.push(newTag);
    },
  },
  watch: {
    refresh(value) {
      this.$refs.slider.refresh(); // PRA RECARREGAS COMPONENTES NÃO HTML / PLUGINS DE TERCEIROS
    },
  },
};
</script>

<style lang="scss">
.form-group {
  &.form-text {
    margin-top: 0;
  }
  &.is-invalid {
    .form-control {
      border-color: red;
    }
  }
}
.form-label {
  display: block;
}
.form-checkbox {
  display: inline-flex;
  flex-direction: row-reverse;
  line-height: 1em;
  // align-items: center;
  .form-label {
    margin-top: 3px;
  }
  .input-group {
    display: block;
    width: auto;
    margin: 3px 6px 0 0;
  }
}
.form-textarea {
  textarea.autoheight {
    overflow: hidden;
    resize: none;
  }
}
.form-datepicker {
  &.dropdown-right {
    .vdp-datepicker__calendar {
      right: 0;
    }
  }
  .form-control {
    padding: 0;
    input {
      width: 100%;
      border: 0;
      padding: 0.375rem 0.75rem;
      background: transparent;

      &[disabled] {
        background-color: #e9ecef;
        opacity: 1;
      }
    }
  }
}
.form-select,
.form-multiselect,
.form-tag,
.form-multitag {
  // position: relative;
  .multiselect {
    min-height: unset;
  }
  .multiselect__tag {
    background-color: gray(500);
  }
  .multiselect__option--highlight {
    background-color: color(primary);
    &:after {
      background-color: color(primary);
    }
  }
  .multiselect__tag-icon {
    &:hover {
      background-color: gray(600);
    }
    &:after {
      color: color(white);
    }
  }
  .form-control {
    padding: 0;
    &.multiselect--active {
      z-index: 4;
    }
    .multiselect__tags {
      background: transparent;
      border: 0;
      min-height: unset;
    }
  }
}

.form-checkbox {
  .form-label {
    display: inline;
    line-height: 20px;
  }
}

.expandSlider {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

// .multiselect__content-wrapper {
//   z-index: 3;
// }
// .multiselect-enter-active, .multiselect-leave-active {
//   transition: none;
// }
// .multiselect__tags {
//   .multiselect__tags-wrap {
//   }
//   .multiselect__input {
//     display: inline;
//     width: auto;
//     max-width: 100%;
//   }
// }
// .form-group {
//   font-size: 1em;
//
//   .form-control, .form-control[readonly] {
//     background-color: #fff;
//
//     &:disabled {
//       background-color: gray(100)
//     }
//   }
//   &.size-1 {
//     .form-control {
//       font-size: .7em;
//       padding: .1em .8em;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/parts/components/input.vue